import { CHAIN_USDC_ADDRESSES } from "../../tokens.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA, WMATIC_ADDRESS } from "../fixture-inputs.js";
export const POLYGON_TEST_CONFIG = {
    balance: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getBalancePolygon",
    },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.polygon,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.polygon,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getTokenBalancePolygon",
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getBlockByNumberPolygon",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.polygon,
        fixture: "getBlockByHashPolygon",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getBlockTransactionsPolygon",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getTransfersPolygon",
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.polygon,
        fixture: "getReceiptPolygon",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.polygon,
        fixture: "getTransactionByHashPolygon",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasPolygon",
    },
    codeQuery: {
        address: CHAIN_USDC_ADDRESSES.polygon,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getCodePolygon",
    },
    logsQuery: {
        address: CHAIN_USDC_ADDRESSES.polygon,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.polygon - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.polygon),
        fixture: "getLogsPolygon",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.polygon,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "simulateCallPolygon",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.polygon,
        fixture: "traceTransactionPolygon",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.polygon,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getTokenMetadataPolygon",
    },
    tokenAllowanceQuery: {
        token: CHAIN_USDC_ADDRESSES.polygon,
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon,
        fixture: "getTokenAllowancePolygon",
    },
    morphoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon, fixture: "getMorphoUserPositionsPolygon" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon, fixture: "getApprovalsPolygon" },
    curvePoolsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.polygon, fixture: "getCurvePoolsPolygon" },
    approvalsRevokeQuery: { address: VITALIK, token: CHAIN_USDC_ADDRESSES.polygon, spender: WMATIC_ADDRESS, fixture: "getApprovalsRevokePolygon" },
};
